(function($){
    $('.global-search__trigger').on('click', function(event) {
        $(this).closest('.header').addClass('search-active');
        $(this).siblings('.global-search__input').focus();
    });

    $('.global-search__input').on('blur', function(event) {
        if(event.relatedTarget != $('.global-search__trigger').get(0) && $(this).val() == '') {
            $(this).closest('.header').removeClass('search-active');
        }
    });
})(jQuery);